export default "/images/5336cc844ce936c6e4de566703e19f34.avif";